import type { InvoiceDataSchemaType } from '@/components/steps/InvoicingStep/invoiceDataSchema';
import SummaryStepSection from '@/components/steps/SummaryStep/SummaryStepSection';
import { useCountryNames } from '@/hooks/useCountryNames';
import { t } from '@/lib/utils';

export type SummaryStepInvoicingSectionProps = {
    goToPage: (stepNumber: number) => void;
    invoicingDataState: InvoiceDataSchemaType;
};

export const SummaryStepInvoicingSection = ({ invoicingDataState, goToPage }: SummaryStepInvoicingSectionProps) => {
    const countryNames = useCountryNames()!;
    const companyCountryWithFlag = countryNames.find(item => item.id === invoicingDataState?.company.country)?.label;
    return (
        <SummaryStepSection title={t('onboarding.invoiceDetails')} goToFunction={() => goToPage(1)}>
            <div className='padding-bottom-5'>
                {`${t('general.invoiceEmailAddress')}: `}
                <strong>{invoicingDataState.invoicing.invoiceEmailAddress}</strong>
            </div>
            <div className='padding-bottom-5'>
                {`${t('general.domesticVATNumber')}: `}
                <strong>{`${invoicingDataState.invoicing.vat} - ${companyCountryWithFlag}`}</strong>
            </div>
            {invoicingDataState.invoicing.schemeId && invoicingDataState.invoicing.participantIdentifier && (
                <div className='padding-bottom-5'>
                    {`${t('general.eInvoicingId')}: `}
                    <strong>{`${invoicingDataState.invoicing.schemeId}:${invoicingDataState.invoicing.participantIdentifier}`}</strong>
                </div>
            )}
        </SummaryStepSection>
    );
};
